<template>
  <ul>
    <li
      :key="item.path"
      v-for="item in data"
      class="first"
      :class="filterItem(item.children) ? 'open' : ''"
      :id="`g_menu_${item.name}`"
    >
      <!-- 有子菜单 -->
      <a
        href="javascript:;"
        v-if="item.meta && item.meta.hasChildrenMenu"
        @click="menuClick(`g_menu_${item.name}`)"
      >
        <Icon :type="item.meta.icon" v-if="item.meta.icon" />
        <span>{{ $t(item.meta.title) }}</span>
        <i class="arrow" v-if="filterItem(item.children)"></i>
      </a>

      <!-- 一级菜单 -->
      <router-link
        :to="{ name: item.name }"
        :class="filterItem(item.children) ? `router-link-active-parent` : ''"
        v-else
      >
        <Icon :type="item.meta.icon" v-if="item.meta.icon" />
        <span>{{ $t(item.meta.title) }}</span>
        <i class="arrow" v-if="filterItem(item.children)"></i>
      </router-link>

      <!-- 递归调用自己 -->
      <MenuItem :data="item.children" v-if="filterItem(item.children)" />
    </li>
  </ul>
</template>

<script>
import { filterChildren } from '@/libs/utils';

export default {
  name: 'MenuItem',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    filterItem(children) {
      return filterChildren(children);
    },

    // 菜单点击
    menuClick(id) {
      console.log('id', id);
      const element = document.getElementById(id);
      const className = element?.getAttribute('class');
      if (/open/gi.test(className)) {
        element.setAttribute('class', className.replace(' open', ' close'));
      } else {
        element.setAttribute('class', className.replace(' close', ' open'));
      }
      return false;
    },
  },
};
</script>
